<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <div class="filter_item">
            <TextFilter :label-text="$t('common.name')"
                        column-name="name"
                        ref="filter_name"
            ></TextFilter>
            <CountryFilter :label-text="$t('common.country')"
                           column-name="country"
                           ref="filter_country"
            ></CountryFilter>
            <IndustryFilter :label-text="$t('common.industry')"
                            column-name="industry"
                            ref="filter_industry"
            ></IndustryFilter>
			<BooleanFilter :label-text="$t('revolvingPutOption.optionProvider')"
						   column-name="canBePutOptionProvider"
						   ref="filter_canBePutOptionProvider"
			></BooleanFilter>
        </div>
    </TableFilter>
</template>
<script>
import IndustryFilter from "@/components/newFilter/IndustryFilter";
import CountryFilter from "@/components/newFilter/CountryFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import TableFilter from "@/components/newFilter/TableFilter";
import BooleanFilter from "@/components/newFilter/BooleanFilter";

export default {
    components: {
		BooleanFilter,
        TableFilter,
        IndustryFilter,
        CountryFilter,
        TextFilter
    },
    data() {
        return {};
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    },
};
</script>

<style lang="scss" scoped>
	::v-deep {
		.filter_button_group {
			position: fixed;
			right: 0 !important;
			top: 215px !important;
		}

		.filter_box {
			position: fixed;
			right: 3rem !important;
			top: 215px !important;
		}
	}
</style>
